import { FlowType } from '../types'

export class SessionData {
  sessionKey: string

  static getSessionData(flow?: string) {
    const flowSessionKey = `InstantInkSignupSession/${flow || FlowType.SMB}`
    const oldSessionKey = 'InstantInkSignupSession'
    const oldSessionData = localStorage.getItem(oldSessionKey)
    if (oldSessionData) {
      console.warn('Converting old session key to flow session key')
      localStorage.setItem(flowSessionKey, oldSessionData)
      localStorage.removeItem(oldSessionKey)
    }
    return new SessionData(flowSessionKey)
  }

  constructor(sessionKey: string) {
    this.sessionKey = sessionKey
  }

  set(data: unknown) {
    const sortKeys = (_: unknown, value: unknown) =>
      value instanceof Object && !Array.isArray(value)
        ? Object.keys(value)
            .sort((a, b) => a.localeCompare(b))
            .reduce((sorted, key) => {
              sorted[key] = value[key]
              return sorted
            }, {})
        : value
    const sessionData = JSON.stringify(data, sortKeys)
    window.localStorage.setItem(this.sessionKey, sessionData)
  }

  get(): Record<string, unknown> {
    return JSON.parse(window.localStorage.getItem(this.sessionKey) || '{}')
  }
}
